import { render, staticRenderFns } from "./MainContentVideoConfs.vue?vue&type=template&id=3293d4da&scoped=true&lang=pug&"
import script from "./MainContentVideoConfs.vue?vue&type=script&lang=js&"
export * from "./MainContentVideoConfs.vue?vue&type=script&lang=js&"
import style0 from "./MainContentVideoConfs.vue?vue&type=style&index=0&id=3293d4da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3293d4da",
  null
  
)

export default component.exports